<script lang="ts">
    import Fab, {Icon} from '@smui/fab';
    import {navigate} from "svelte-routing";
    import {Svg} from "@smui/common/elements";

    export let fallbackPath;

    function nav() {
        if (document.referrer.startsWith('https://roses-inlab.fib.upc.edu')) {
            history.back();
        } else {
            navigate(fallbackPath);
        }
    }

</script>


<Fab on:click={nav} class="back-button">
    <Icon component={Svg} viewBox="2 2 20 20">
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path>
    </Icon>
</Fab>

<style>
    :global(.back-button) {
        position: absolute !important;
        top: 5vh;
        left: 2vw;
    }

    @media (max-width: 800px) {
        :global(.back-button) {
            left: auto;
            right: 2vw;
        }
    }
</style>